/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Contacts_Modal_Empty1Inputs */

const en_coinvestments_contacts_modal_empty1 = /** @type {(inputs: Coinvestments_Contacts_Modal_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No contacts found for this organisation.`)
};

/**
* | output |
* | --- |
* | "No contacts found for this organisation." |
*
* @param {Coinvestments_Contacts_Modal_Empty1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_contacts_modal_empty1 = /** @type {((inputs?: Coinvestments_Contacts_Modal_Empty1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Contacts_Modal_Empty1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_contacts_modal_empty1(inputs)
});
export { coinvestments_contacts_modal_empty1 as "coInvestments_contacts_modal_empty" }